import axios from "axios";

const backendUrl =
  process.env.REACT_APP_BACKEND_URL || "https://incolour-backend.onrender.com";

const api = axios.create({
  baseURL: `${backendUrl.replace(/\/$/, "")}/api`,
  timeout: 10000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("incolour_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Keep sitemap.xml fresh: after any CMS save/delete, ask the backend to regenerate it.
api.interceptors.response.use((res) => {
  const method = res.config?.method;
  const url = res.config?.url || "";
  if (
    ["post", "put", "delete"].includes(method) &&
    /^\/admin\/(projects|journal)/.test(url)
  ) {
    api.post("/admin/regenerate-sitemap").catch(() => {});
  }
  return res;
});

export function embedUrl(url) {
  if (!url) return null;

  const yt = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/
  );
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;

  const vm = url.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;

  return url;
}

export function formatDate(iso) {
  if (!iso) return "";

  try {
    return new Date(iso).toLocaleDateString("en-CA", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return iso;
  }
}

export default api;
